<template>
  <div>
    <div class="orderOver orderCom" v-if="from === 1">
      <div class="flexB">
        <van-icon name="checked" />
        <p class="text">下单成功</p>
      </div>
      <van-button type="primary" @click="goDetail">查看订单详情</van-button>
    </div>
    <div class="orderOver orderQr" v-if="from === 0">
      <div class="flexB">
        <div v-if="showQRCode" id="qrcode"></div>
        <p class="text">
          联系您的服务顾问扫描上方二维码 完成订单的最终确认才能生效 （30分钟未确认，订单将自动取消）
        </p>
      </div>
      <van-button type="primary" @click="goDetail">查看订单详情</van-button>
    </div>
  </div>
</template>
<script>
import { useRoute, useRouter } from 'vue-router'
import { reactive, toRefs, onMounted, nextTick, onUnmounted } from 'vue'
import QRCode from 'qrcodejs2'
import { getOrderDetail } from '@/api/order'

export default {
  setup() {
    let route = useRoute()
    let router = useRouter()
    const state = reactive({
      orderData: route.query.orderNum,
      from: Number(route.query.fromQr),
      orderId: route.query.orderId,
      qrcode: null,
      showQRCode: false,
      // 轮胎订单刷新时间/毫秒
      refreshTime: 4000
    })
    // 轮询刷新
    let refresh = async () => {
      try {
        const id = state.orderId
        if (!id) return
        const data = await getOrderDetail({ id })
        // 轮胎订单,待扫码确认
        if (data.orderTypeFlag === 3) {
          if (data.orderStatusFlag === 1) {
            setTimeout(() => {
              refresh && refresh()
            }, state.refreshTime)
          } else {
            router.replace({ path: '/orderDetail', query: { orderId: state.orderId } })
          }
        } else {
          refresh = null
        }
      } catch (e) {
        console.error('轮询刷新错误', e)
      }
    }
    const goDetail = () => {
      router.replace({ path: '/orderDetail', query: { orderId: state.orderId } })
    }
    const makeQrcode = () => {
      let URL = `?from=OrderOver&orderNo=${state.orderData}`
      state.showQRCode = true
      if (state.qrcode) {
        nextTick(() => {
          state.qrcode.clear() // 清除代码
          state.qrcode.makeCode(URL)
        })
      } else {
        nextTick(() => {
          state.qrcode = new QRCode('qrcode', {
            width: 200,
            height: 200,
            text: URL, // 二维码地址
            colorDark: '#000',
            colorLight: '#fff'
          })
        })
      }
      refresh()
    }
    onUnmounted(() => {
      refresh = null
    })
    onMounted(() => {
      route.query.fromQr == 0 && makeQrcode()
    })
    return {
      ...toRefs(state),
      goDetail,
      makeQrcode
    }
  }
}
</script>
<style lang="scss" scoped>
.orderOver {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;
  padding-bottom: 20px;
  box-sizing: border-box;
  .flexB {
    :deep(.van-icon) {
      font-size: 90px;
      color: #3088c5;
    }
    .text {
      margin: 0 auto;
      font-size: 14px;
      margin-top: 20px;
      width: 60%;
    }
    #qrcode {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
    }
  }
  :deep(.van-button) {
    width: 160px;
    margin: 0 auto;
    // margin-top: 30%;
    background-color: #3088c5;
  }
}
</style>
